"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanMeta = exports.cleanErrors = void 0;
var cleanMeta = {
  touched: false,
  blurred: false,
  changed: false,
  succeeded: false,
  asyncValidationInFlight: false
};
exports.cleanMeta = cleanMeta;
var cleanErrors = {
  client: "pending",
  external: "unchecked"
};
exports.cleanErrors = cleanErrors;